export enum DataValidationKinds {
  FullWidth = 1,
  FullKana = 2,
  HalfKana = 3,
  HalfNumber = 4,
  AlphabetNumber = 5,
}
